/* src/app/common/components/quantity-selector/quantity-selector.component.scss */
:host {
  display: inline-block;
}
ion-buttons {
  border: 1px solid var(--ion-color-primary);
  border-radius: 25px;
  width: 150px;
  margin: auto;
}
ion-buttons.no-borders {
  border-width: 0;
}
ion-input {
  --padding-start: 0;
  --padding-end: 0;
}
.count {
  width: 50px;
  font-size: 16px;
}
.count ::ng-deep .native-input[disabled].sc-ion-input-md {
  opacity: 1;
}
/*# sourceMappingURL=quantity-selector.component.css.map */
